// Officer status utilities — extracted from MyScripts/Utils.ts

import moment from 'moment';
import { timeSinceFormatted } from './date-time';

export function processOfficerStatusListFromResult(result: any): void {
  for (let officerStatus of result.officerStatusList) {
    if (officerStatus.status == 100) {
      officerStatus.status = "Cleared";
    } else if (officerStatus.status == 200) {
      officerStatus.status = "On-Scene";
    } else if (officerStatus.status == 300) {
      officerStatus.status = "En-Route";
    } else if (officerStatus.status == 400) {
      officerStatus.status = "Dispatched";
    } else if (officerStatus.isOnline) {
      if (officerStatus.manualStatus == 2) {
        officerStatus.status = "Unavailable";
      } else {
        officerStatus.status = "Available";
      }
    } else {
      officerStatus.status = "Offline";
    }

    if (officerStatus.lastActiveTime) {
      officerStatus.lastActiveTime = timeSinceFormatted(moment(officerStatus.lastActiveTime).utc());
    } else {
      officerStatus.lastActiveTime = "n/a";
    }
    if (officerStatus.activeCall) {
      const nocNames = officerStatus.activeCall.natureOfCallValues.join(", ");
      officerStatus.activeCall = { id: officerStatus.activeCall.id, display: officerStatus.activeCall.eventId + " | " + nocNames };
    }
    if (!officerStatus.location) {
      officerStatus.location = "n/a";
    }
  }
}
